module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT"
    }
  }, [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("I’d like to acknowledge everyday adventures (even though they’re not human) because it has helped me. Again, I’d like to include Liz Pichon although she doesn’t know me because she was the start of my writing career. As an 11-year-old, it shows anything is possible. Age is just a number, so don’t let that stop you. It all just starts with imagination, inspiration, perseverance and support from your parents.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0